import { loadStripe } from '@stripe/stripe-js';
import {
  EmbeddedCheckoutProvider,
  EmbeddedCheckout
} from '@stripe/react-stripe-js';
import { decodeData } from '../../utils/Helper';
import { Config } from '../../config/Config';
import { useEffect } from 'react';

const stripePromise = loadStripe(decodeData(Config?.STRIPE_PUBLIC_KEY));

const CheckoutForm = ({ clientSecret }: { clientSecret: string }) => {
  const options = { clientSecret };

  useEffect(() => {
    const embeddedCheckout = document.getElementById("checkout");

    if (embeddedCheckout) {
      console.log('embeddedCheckout------------>', embeddedCheckout);

      embeddedCheckout.addEventListener("checkoutSessionCompleted", (event) => {
        console.log("Payment Success Event: ", event);
      });

      embeddedCheckout.addEventListener("checkoutSessionFailed", (event) => {
        console.log("Payment failed: ", event);
      });
    }
    return () => {
      if (embeddedCheckout) {
        embeddedCheckout.removeEventListener("checkoutSessionCompleted", () => { });
      }
    };
  }, []);

  return (
    <div id="checkout">
      <EmbeddedCheckoutProvider
        stripe={stripePromise}
        options={options}
      >
        <EmbeddedCheckout />
      </EmbeddedCheckoutProvider>
    </div>
  )
}

export default CheckoutForm;